import React, { useContext, useEffect, useState } from 'react'
import { func } from 'prop-types'
import styled from '@emotion/styled'

// IMPORT COMPONENTS
import { Element, StyledLink, IconWrapper } from './'
import { ElementIcon } from '../HeaderBanner'
import { KebabMenu } from './KebabMenu'
import { Search as SearchIcon } from '../svgs/Search'
import { SiteConfigContext } from '../SiteConfigProvider'

const BndLinksCenterWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin: 16px auto;
	width: 50%;

	li {
		border-right: 2px solid ${({ theme }) => theme.colors.gray[200]};
		margin: auto 0;
		padding: 0 2rem;

		&:last-child {
			border-right: none;
		}
	}
`
const BndLinksRightWrapper = styled.div`
	display: flex;
	position: absolute;
	top: 38px;
	right: 0px;
`

/**
 * Navigation Links Layout for BND
 *
 * TODO: this whole compoennt will be deprecated after the new header is rolled out
 */
export function NavigationLinksBnd({ handleSearchNavClick }) {
	const {
		siteConstants: { HUB_LINKS },
	} = useContext(SiteConfigContext)

	const [displayedLinks, setDisplayedLinks] = useState()
	const [hiddenLinks, setHiddenLinks] = useState()
	const maxDesktopWidth = 1600
	const largeDesktopWidth = 1400
	const mediumDesktopWidth = 1200
	const smallDesktopWidth = 1000

	const maxDesktopLinks = 6
	const largeDesktopLinks = 5
	const mediumDesktopLinks = 4
	const smallDesktopLinks = 3

	useEffect(() => {
		const handleNavLinksDisplay = () => {
			const windowWidth = window.innerWidth
			const numOfLinks =
				windowWidth > maxDesktopWidth
					? maxDesktopLinks
					: window.innerWidth > largeDesktopWidth
					? largeDesktopLinks
					: window.innerWidth > mediumDesktopWidth
					? mediumDesktopLinks
					: window.innerWidth > smallDesktopWidth
					? smallDesktopLinks
					: 0

			setDisplayedLinks(HUB_LINKS.slice(0, numOfLinks))
			setHiddenLinks(HUB_LINKS.slice(numOfLinks, HUB_LINKS.length))
		}
		handleNavLinksDisplay()
		window.addEventListener('resize', handleNavLinksDisplay)

		return () => {
			window.removeEventListener('resize', handleNavLinksDisplay)
		}
	}, [HUB_LINKS])

	return (
		<>
			<BndLinksCenterWrapper>
				{displayedLinks &&
					displayedLinks.map(({ isHighlighted = false, slug, title }, i) => {
						return (
							<Element key={i}>
								<StyledLink aria-label={title} href={slug} isHighlighted={isHighlighted}>
									{title}
								</StyledLink>
							</Element>
						)
					})}
			</BndLinksCenterWrapper>
			<BndLinksRightWrapper>
				{hiddenLinks && hiddenLinks.length !== 0 && <KebabMenu menuItems={hiddenLinks} />}
				<ElementIcon onClick={handleSearchNavClick}>
					<IconWrapper>
						<SearchIcon />
					</IconWrapper>
				</ElementIcon>
			</BndLinksRightWrapper>
		</>
	)
}
NavigationLinksBnd.propTypes = {
	handleSearchNavClick: func,
}
